<div [sq-action-buttons]="options"></div>